import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyGetProduct = async (id) => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `{
          product(id: "gid://shopify/Product/${id}") {
            id
            title
            productType
            variants(first: 100) {
              edges {
                node {
                  id
                  title
                  price {
                    amount
                  }
                  image {
                    url(transform: {maxHeight: 100})
                  }
                  selectedOptions {
                    name
                    value
                  }
                  zones: metafield(key:"patch_zones_metadata", namespace:"integration") {
                    value
                  }
                  width: metafield(key:"patch_scale_width", namespace:"integration") {
                    value
                  }
                  height: metafield(key:"patch_scale_height", namespace:"integration") {
                    value
                  }
                  underThree: metafield(key:"under_three_years_old", namespace:"custom") {
                    value
                  }
                }
              }
            }
            options(first: 5) {
              id
              name
              values
            }
            pointsIncluded: metafield(key:"product_patch_points", namespace:"my_fields") {
              value
            }
            onlineStoreUrl
          }
        }`,
      },
    });
    if (response.data.data.product) {
      const { product } = response.data.data;
      return {
        ...product,
        variants: product.variants.edges.map((e) => e.node),
      };
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyGetProduct;
